import { TRANSLATIONS_NAMESPACE } from '../../../constants/locale';
import { useTranslation } from '../../../contexts/translation-context';
const ERROR_MESSAGE_KEY = 'submit.failed.message';
export function useSubmitErrorMessage(errorMessageCode) {
  const {
    t,
    i18n
  } = useTranslation();
  if (!errorMessageCode) {
    return undefined;
  }
  const errorMessageKeyByCode = `${ERROR_MESSAGE_KEY}.${errorMessageCode}`;
  const errorMessageKey = i18n.exists(`${TRANSLATIONS_NAMESPACE}:${errorMessageKeyByCode}`) ? errorMessageKeyByCode : ERROR_MESSAGE_KEY;
  return t(errorMessageKey);
}
//# sourceMappingURL=use-submit-error.js.map